import { NewsResponse } from "./News";

// Backend API base URL (adjust if different)
const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:7845';

export interface FetchNewsParams {
  q?: string;
  from_date?: string;
  to_date?: string;
  language?: string;
  country?: string;
  category?: string;
  domain?: string;
  page?: string; // pagination cursor from `nextPage`
}

export async function fetchNews(params: FetchNewsParams): Promise<NewsResponse> {
  const query = new URLSearchParams();

  if (params.q) query.append("q", params.q);
  // if (params.from_date) query.append("from_date", params.from_date);
  // if (params.to_date) query.append("to_date", params.to_date);
  // if (params.language) query.append("language", params.language);
  // if (params.country) query.append("country", params.country);
  // if (params.category) query.append("category", params.category);
  // if (params.domain) query.append("domain", params.domain);
  if (params.page) query.append("page", params.page); // <-- important for next page

  const response = await fetch(`${BASE_URL}/api/news?${query.toString()}`);
  if (!response.ok) {
    throw new Error(`Error fetching news: ${response.statusText}`);
  }
  return (await response.json()) as NewsResponse;
}